import { XSOLN_PREFIX } from '../../constants/dataSource.constants';
import { combinePath } from '../../dataConnections/dataConnection.utils';
import { parseXmlNative } from '../../utility/xmlHelpers';
import { isInHostWebDomain } from '../sharePoint/sharePointHelper';

const parseXml = parseXmlNative;

function getTemplateFileAsync(template, url) {
    var urlStripped = url.replace(XSOLN_PREFIX, '');

    return template.getTemplateFileAsync(urlStripped).then(function (data) {
        return data && parseXml(data);
    });
}

function xmlFileAdapter(definition, api, shpAccess, template) {
    var fileUrl = definition.fileUrl,
        url =
            fileUrl.indexOf(XSOLN_PREFIX) === 0
                ? fileUrl
                : combinePath(template.getBasePath(), fileUrl);

    function setUrl(queryUrl) {
        url = queryUrl;
    }

    function queryRestAsync() {
        return api.getXmlAsync(url).then(parseXml);
    }

    function queryFromSharePointAsync(queryUrl) {
        return shpAccess
            .queryXmlAsync(queryUrl)
            .then(parseXml)
            .catch(function (error) {
                throw new Error(
                    `An error occurred querying '${queryUrl}'. The URL format may not be supported.\n\nError:\n${error.message}`,
                );
            });
    }

    // 2025-03-26 - Removed getAnonymousQueryRelativeurl() which seemed to be serving
    //              no purpose and was altering parts of the URL (e.g. URL-escaping them)

    function performQueryAsync() {
        if (url.indexOf(XSOLN_PREFIX) === 0 || url.indexOf('/') === -1) {
            return getTemplateFileAsync(template, url);
        }

        if (isInHostWebDomain(url)) {
            if (!url) {
                throw new Error(
                    'Unable to determine correct path to query for URL: ' + url,
                );
            }

            return queryFromSharePointAsync(url);
        }

        return queryRestAsync();
    }

    function executeAsync(dataSource) {
        return performQueryAsync().then(function (dataXml) {
            if (dataXml) {
                dataSource.setDom(dataXml);
            } else {
                throw new Error('An error occurred querying a data source.');
            }
        });
    }

    function getUrl() {
        return url;
    }

    // interface
    return {
        executeAsync,
        setUrl,
        getUrl,
    };
}

export default xmlFileAdapter;
